/**
 * Filter Distribution Records Use Case
 *
 * This use case handles the business logic for filtering distribution records.
 * It follows Single Responsibility Principle by handling only filtering logic.
 *
 * @module FilterDistributionRecordsUseCase
 */

import {DistributionRecord, DistributionFilters} from '../models/distribution.model';

export class FilterDistributionRecordsUseCase {
  /**
   * Execute the use case to filter distribution records
   * @param records - Array of distribution records
   * @param filters - Filter criteria
   * @returns Array of filtered records
   */
  execute (records: DistributionRecord[], filters: DistributionFilters): DistributionRecord[] {
    return records.filter(record => {
      // Marketer filter
      if (filters.marketerId && record.marketerId !== filters.marketerId) {
        return false;
      }

      // Product filter
      if (filters.productId && record.productId !== filters.productId) {
        return false;
      }

      // Status filter
      if (filters.status && record.status !== filters.status) {
        return false;
      }

      // Date range filter
      if (filters.dateFrom && new Date(record.deliveredAt) < new Date(filters.dateFrom)) {
        return false;
      }

      if (filters.dateTo && new Date(record.deliveredAt) > new Date(filters.dateTo)) {
        return false;
      }

      // Serial filter
      if (filters.hasSerial !== undefined && record.hasSerial !== filters.hasSerial) {
        return false;
      }

      // Quantity range filters
      if (filters.minQuantity !== undefined && record.quantity < filters.minQuantity) {
        return false;
      }

      if (filters.maxQuantity !== undefined && record.quantity > filters.maxQuantity) {
        return false;
      }

      return true;
    });
  }
}

